export enum AccountLinkingCardTypeEnum {
    ERROR = 'error',
    LINKED = 'linked',
    DEFAULT = 'default',
}
